import { INDEX_PATH } from '@/router/router';

export const isIndexPath = (path: string): path is typeof INDEX_PATH =>
  path === INDEX_PATH;
